import { render, staticRenderFns } from "./popup-material-other.vue?vue&type=template&id=156a849c&scoped=true"
import script from "./popup-material-other.vue?vue&type=script&lang=js"
export * from "./popup-material-other.vue?vue&type=script&lang=js"
import style0 from "./popup-material-other.vue?vue&type=style&index=0&id=156a849c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a849c",
  null
  
)

export default component.exports